import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  triptychWrapper: {
    display: 'flex',
    marginTop: '60px',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '1000px',
    margin: '0 auto',
    "@media (max-width: 850px)": {
     flexDirection: 'column'
    }
  }
}));